import { type ReactNode } from 'react'

import { Icon } from '@/components/icons/Icon'
import { type RecType } from '@/defs/rec'
import { useCardsRec } from '@/hooks/useCardsRec'
import { useInView } from '@/hooks/useInView'

import { CardLink } from '../CardLink/CardLink'

import styles from './CardAutoLink.module.scss'

type Props = {
  children: ReactNode
  className?: string
  rec: RecType
}

export const CardAutoLink = ({ children, className, rec }: Props) => {
  const { inViewStatus, ref } = useInView()
  const { card } = useCardsRec({ enabled: inViewStatus === 'inView', rec })

  return (
    <CardLink className={className} rec={{ ...rec, role: card?.isLegalCommander ? 'commander' : 'card' }} ref={ref}>
      {children}
      <span className={styles.cardIcon}>
        <Icon name='cards' />
      </span>
    </CardLink>
  )
}
